import { render, staticRenderFns } from "./landscape.vue?vue&type=template&id=42de0706&scoped=true&"
import script from "./landscape.vue?vue&type=script&lang=js&"
export * from "./landscape.vue?vue&type=script&lang=js&"
import style0 from "./landscape.vue?vue&type=style&index=0&id=42de0706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42de0706",
  null
  
)

export default component.exports